import { render, staticRenderFns } from "./bPlus.vue?vue&type=template&id=2ab7d816&scoped=true&"
import script from "./bPlus.vue?vue&type=script&lang=js&"
export * from "./bPlus.vue?vue&type=script&lang=js&"
import style0 from "./bPlus.vue?vue&type=style&index=0&id=2ab7d816&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab7d816",
  null
  
)

component.options.__file = "bPlus.vue"
export default component.exports